import React from 'react';
import { Box, Typography, Fade } from '@mui/material';
import ParticipantAvatar from './ParticipantAvatar';
import MicOffIndicator from './MicOffIndicator';

/**
 * Picture-in-Picture Video Box Component
 * Shows local video in bottom-right corner
 */
function PipVideoBox({
  localVideoRef,
  localStream,
  isVideoEnabled,
  isScreenSharing,
  isAudioEnabled,
  currentUserImage,
  currentUserName,
}) {
  return (
    <Fade in={!!localStream}>
      <Box
        sx={{
          position: 'absolute',
          bottom: { xs: 80, sm: 90 },
          right: 16,
          width: { xs: 120, sm: 200, md: 280 },
          height: { xs: 90, sm: 150, md: 210 },
          borderRadius: 2,
          overflow: 'hidden',
          border: isScreenSharing ? '3px solid #1976d2' : '2px solid white',
          backgroundColor: '#1a1a1a',
          zIndex: 50,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
        }}
      >
        {(isVideoEnabled || isScreenSharing) ? (
          <>
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            <video
              ref={localVideoRef}
              autoPlay
              playsInline
              muted
              style={{
                width: '100%',
                height: '100%',
                objectFit: isScreenSharing ? 'contain' : 'cover',
                transform: isScreenSharing ? 'none' : 'scaleX(-1)',
                backgroundColor: '#000',
              }}
            />
            
            {isScreenSharing && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 8,
                  left: 8,
                  backgroundColor: 'primary.main',
                  color: 'white',
                  px: 1,
                  py: 0.5,
                  borderRadius: 1,
                  fontSize: { xs: '0.65rem', sm: '0.75rem' },
                  fontWeight: 600,
                  zIndex: 60,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                }}
              >
                <Typography variant="caption" sx={{ fontWeight: 600 }}>
                  Sharing Screen
                </Typography>
              </Box>
            )}
             
            {!isAudioEnabled && <MicOffIndicator size="small" />}
          </>
        ) : (
          // Camera off - show avatar
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#2a2a2a',
              color: 'white',
            }}
          >
            <Box
              sx={{
                width: { xs: 50, sm: 80, md: 100 },
                height: { xs: 50, sm: 80, md: 100 },
                borderRadius: '50%',
                overflow: 'hidden',
                mb: 1,
                border: '2px solid white',
              }}
            >
              <img
                src={currentUserImage}
                alt={currentUserName}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </Box>
            
            <Typography variant="caption" sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem' } }}>
              Camera Off
            </Typography>
             
            {!isAudioEnabled && <MicOffIndicator size="small" />}
          </Box>
        )}
      </Box>
    </Fade>
  );
}

export default PipVideoBox;
